import { nodeToId } from "@services/shopify";

export function mergeShopifyAndSanityProducts(sanityProductGroup, shopifyProductVariants) {
  // Merge the Product and Variant data coming from Shopify with the data from sanity
  const availableProducts = shopifyProductVariants.map((product) => {
    if (!product) return;
    const result = sanityProductGroup.shopifyProducts.find(
      (shopifyProduct) =>
        product.handle  === shopifyProduct.productReferenceV2.store.slug.current
    );

    if (result) {
      return {
        ...result,
        totalInventory: product.totalInventory,
        availableForSale: product.availableForSale,
        media: product.media,
        productReferenceV2: {
          ...result.productReferenceV2,
          tags: product.tags,
          handle: product.handle,
          description: product.description,
          id: product.id,
          options: product.options,
          variants: product.variants,
        },
      };
    }
  });

  return {
    ...sanityProductGroup,
    shopifyProducts: availableProducts.filter((product) => product !== undefined),
  };
}
